// extracted by mini-css-extract-plugin
export default {"StaticCanvasPagesContainer":"canvasStyles_StaticCanvasPagesContainer__C8bqU"};